import axios from '@/libs/api.request'
import fileAxios from '@/libs/file.request'

// 证书列表
export const apiCertificatesList = data => {
  return axios.request({
    url: '/admin/certificates',
    method: 'get',
    data
  })
}
// 证书详情
export const apiCertificatesDetail = (id, data) => {
  return axios.request({
    url: `/admin/certificates/${id}`,
    method: 'get',
    data
  })
}
// 新增证书
export const apiCertificatesAdd = data => {
  return axios.request({
    url: '/admin/certificates',
    method: 'post',
    data
  })
}
// 编辑证书
export const apiCertificatesEdit = (id, data) => {
  return axios.request({
    url: `/admin/certificates/${id}`,
    method: 'put',
    data
  })
}
// 删除证书
export const apiCertificatesDetele = (id, data) => {
  return axios.request({
    url: `/admin/certificates/${id}`,
    method: 'delete',
    data
  })
}
// 证书列表导出
export const apiCertificatesExport = (data) => {
  return fileAxios.request({
    url: `/admin/certificates/users-leading-out`,
    method: 'get',
    data
  })
}

// 证书模板详情
export const apiCertificatesTempDetail = (id, data) => {
  return axios.request({
    url: `/admin/certificates/template/${id}`,
    method: 'get',
    data
  })
}
// 证书模板更新
export const apiCertificatesTempUpdate = (id, data) => {
  return axios.request({
    url: `/admin/certificates/template/${id}`,
    method: 'patch',
    data
  })
}

// 证书字段列表
export const apiCertificatesFieldsList = data => {
  return axios.request({
    url: '/admin/certificates/fields',
    method: 'get',
    data
  })
}
// 证书字段详情
export const apiCertificatesFieldsDetail = (id, data) => {
  return axios.request({
    url: `/admin/certificates/fields/${id}`,
    method: 'get',
    data
  })
}
// 新增证书字段
export const apiCertificatesFieldsAdd = data => {
  return axios.request({
    url: '/admin/certificates/fields',
    method: 'post',
    data
  })
}
// 编辑证书字段
export const apiCertificatesFieldsEdit = (id, data) => {
  return axios.request({
    url: `/admin/certificates/fields/${id}`,
    method: 'put',
    data
  })
}
// 删除证书字段
export const apiCertificatesFieldsDetele = (id, data) => {
  return axios.request({
    url: `/admin/certificates/fields/${id}`,
    method: 'delete',
    data
  })
}

// 用户证书列表
export const apiCertificatesUsersList = data => {
  return axios.request({
    url: '/admin/certificates/users',
    method: 'get',
    data
  })
}
// 用户证书详情
export const apiCertificatesUsersDetail = (id, data) => {
  return axios.request({
    url: `/admin/certificates/users/${id}`,
    method: 'get',
    data
  })
}
// 新增用户证书
export const apiCertificatesUsersAdd = data => {
  return axios.request({
    url: '/admin/certificates/users',
    method: 'post',
    data
  })
}
// 编辑用户证书
export const apiCertificatesUsersEdit = (id, data) => {
  return axios.request({
    url: `/admin/certificates/users/${id}`,
    method: 'put',
    data
  })
}
// 删除用户证书
export const apiCertificatesUsersDetele = (id, data) => {
  return axios.request({
    url: `/admin/certificates/users/${id}`,
    method: 'delete',
    data
  })
}
// 搜索证书
export const apiCertificatesSearch = data => {
  return axios.request({
    url: '/admin/certificates/all',
    method: 'get',
    data
  })
}
// 下载导入模板
export const apiCertificatesUsersDownload = (id, data) => {
  return fileAxios.request({
    url: `/admin/certificates/users/template/${id}`,
    method: 'get',
    data
  })
}
// 用户证书更新
export const apiCertificatesUsersUpdate = (id, data) => {
  return axios.request({
    url: `/admin/certificates/users/generate/${id}`,
    method: 'get',
    data
  })
}
